module.exports = __webpack_public_path__ + "img/logo-6.7babc8ac.svg";